module.exports = __webpack_public_path__ + "img/board_edit-zh.439da848.png";